import {
  USER_LIST,
  USER_SEARCH,
  USER_REGISTER_BY_ADMIN,
  USER_UPDATE,
  USER_DELETE,
  USER_UNLOCK,
  USER_RESET_PASSWORD_EMAIL,
} from "../../../api/ApiEndpoints";
import api from "../../../interceptor/Interceptor";
import {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  addUserStart,
  addUserSuccess,
  addUserFailure,
  editUserStart,
  editUserSuccess,
  editUserFailure,
  deleteUsersStart,
  deleteUsersSuccess,
  deleteUsersFailure,
  unlockUserStart,
  unlockUserSuccess,
  unlockUserFailure,
  resetPasswordEmailStart,
  resetPasswordEmailSuccess,
  resetPasswordEmailFailure,
} from "../../reducer/userReducer/UserReducer";

const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

// .................... List / Search ...........................

export const fetchUsers = (query) => async (dispatch) => {
  dispatch(fetchUsersStart());
  try {
    const url = query
      ? `${USER_SEARCH}?query=${encodeURIComponent(query)}`
      : USER_LIST;
    const response = await api.get(url);
    dispatch(fetchUsersSuccess(response.data.users || []));
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to fetch users");
    dispatch(fetchUsersFailure(message));
    return { success: false, error: message };
  }
};

// .................... Add ...........................

export const addUser = (newUser) => async (dispatch) => {
  dispatch(addUserStart());
  try {
    await api.post(USER_REGISTER_BY_ADMIN, newUser);
    dispatch(addUserSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to add user");
    dispatch(addUserFailure(message));
    return { success: false, error: message };
  }
};

// .................... Edit ...........................

export const editUser = (updatedUser) => async (dispatch) => {
  dispatch(editUserStart());
  try {
    await api.put(`${USER_UPDATE}${updatedUser.email}`, updatedUser);
    dispatch(editUserSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to update user");
    dispatch(editUserFailure(message));
    return { success: false, error: message };
  }
};

// .................... Delete ...........................

export const deleteUsers = (emails) => async (dispatch) => {
  dispatch(deleteUsersStart());
  try {
    await api.post(USER_DELETE, { emails });
    dispatch(deleteUsersSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to delete user(s)");
    dispatch(deleteUsersFailure(message));
    return { success: false, error: message };
  }
};

// .................... Unlock ...........................

export const unlockUser = (email) => async (dispatch) => {
  dispatch(unlockUserStart());
  try {
    await api.put(`${USER_UNLOCK}${email}`);
    dispatch(unlockUserSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to unlock user");
    dispatch(unlockUserFailure(message));
    return { success: false, error: message };
  }
};

// .................... Reset password email ...........................

export const sendResetPasswordEmail = (email, name) => async (dispatch) => {
  dispatch(resetPasswordEmailStart());
  try {
    await api.post(USER_RESET_PASSWORD_EMAIL, { email, name });
    dispatch(resetPasswordEmailSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to send password reset email");
    dispatch(resetPasswordEmailFailure(message));
    return { success: false, error: message };
  }
};
